/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {AVAILABLE_YEARS, HIGHCHART_COLORS} from '../../../../libs/constant'

import React, {FC, useEffect, useState} from 'react'
import Highcharts from 'highcharts/es-modules/masters/highcharts.src'
import 'highcharts/es-modules/masters/highcharts-more.src'
import 'highcharts/es-modules/masters/modules/exporting.src'
import 'highcharts/es-modules/masters/modules/offline-exporting.src'
import 'highcharts/es-modules/masters/modules/export-data.src'
import HighchartsReact from 'highcharts-react-official'
import {Dropdown, Card, Row, Spinner} from 'react-bootstrap'
import {getListBilateralTradeData} from '../core/_request'
import * as _ from 'lodash'
import {getNameByISO3, shortenLargeNumber} from '../../../../libs/misc'
import {useAuth} from '../../../../modules/auth'

type TopCommodityChartCardProps = {
  handlePartnerClicked: (partner: string, year: number, flow: string) => void
}

interface ExtendedHighchartPiePoint {
  key: string
  x: number
  y: number
  percentage: number
  name: string
  trade_value: number
}

interface ExtendedHighchartCreditInterface {
  credits: any
}

interface TopTradeObj {
  name: string
  trade_value: number
  y: number
}

const TopCommodityChartCard: FC<TopCommodityChartCardProps> = ({handlePartnerClicked}) => {
  const {currentUser} = useAuth()
  const reporterISO3User = currentUser?.economy
  const highchartOptions = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      marginTop: 0,
      events: {
        load: function (this: ExtendedHighchartCreditInterface) {
          this.credits.element.onclick = function () {
            window.open('http://comtrade.un.org', '_blank')
          }
        },
      },
    },
    tooltip: {
      headerFormat: '',
      pointFormatter: function () {},
    },
    title: {
      text: '',
    },
    series: [
      {
        data: [1, 2, 3],
      },
    ],
    plotOptions: {
      pie: {
        size: '60%',
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          formatter: function (this: ExtendedHighchartPiePoint) {
            const {key, percentage} = this
            const dataLabel = percentage < 0.01 ? '<0.01' : percentage.toFixed(2)
            return `${key}: ${dataLabel}%`
          },
          style: {
            color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
            fontWeight: 'normal',
          },
          // connectorColor: 'silver'
        },
      },
    },
    credits: {
      enabled: true,
      text: `Data source: UN Comtrade`,
      href: '#',
      position: {
        align: 'center',
      },
    },
    exporting: {
      enabled: true,
    },
    accessibility: {
      enabled: false,
    },
  }
  const [isLoading, setIsLoading] = useState(false)
  const [selectedYear, setSelectedYear] = useState(AVAILABLE_YEARS[0])
  const [importPieChartOptions, setImportPieChartOptions] = useState<any>(highchartOptions)
  const [exportPieChartOptions, setExportPieChartOptions] = useState<any>(highchartOptions)
  const [worldImportTradeValue, setWorldImportTradeValue] = useState(0)
  const [worldExportTradeValue, setWorldExportTradeValue] = useState(0)
  const [topImportSources, setTopImportSources] = useState<TopTradeObj[]>([])
  const [topExportDest, setTopExportDest] = useState<TopTradeObj[]>([])

  const generateBilateralPiechartTradeData = (year) => {
    getListBilateralTradeData(reporterISO3User, year)
      .then((res) => {
        const tradeData = res.data
        if (tradeData.length < 1) {
          throw Error('Error')
        }

        const worldImportData = tradeData.filter((trade) => trade.par === 'WLD' && trade.flow === 1)
        const worldExportData = tradeData.filter((trade) => trade.par === 'WLD' && trade.flow === 2)

        setWorldImportTradeValue(worldImportData[0].val)
        setWorldExportTradeValue(worldExportData[0].val)

        const importDataSorted = _.chain(tradeData)
          .filter((obj) => obj.par !== 'WLD' && obj.flow === 1)
          .orderBy('val', 'desc')
          .value()
        const exportDataSorted = _.chain(tradeData)
          .filter((obj) => obj.par !== 'WLD' && obj.flow === 2)
          .orderBy('val', 'desc')
          .value()
        const topImportData = importDataSorted.slice(0, 9).map((trade) => {
          return {
            ...trade,
            percentage: ((trade.val / worldImportData[0].val) * 100).toFixed(4),
          }
        })

        const topExportData = exportDataSorted.slice(0, 9).map((trade) => {
          return {
            ...trade,
            percentage: ((trade.val / worldExportData[0].val) * 100).toFixed(4),
          }
        })
        const otherImportData = importDataSorted
          .slice(topImportData.length + 1, importDataSorted.length)
          .reduce((acc, trade) => (acc += trade.val), 0)
        const otherExportData = exportDataSorted
          .slice(topExportData.length + 1, exportDataSorted.length)
          .reduce((acc, trade) => (acc += trade.val), 0)

        const graphDatasetImport = [
          ...topImportData.map((trade, idx) => {
            return {
              name: getNameByISO3(trade.par),
              y: +trade.percentage,
              trade_value: trade.val,
              color: HIGHCHART_COLORS[idx],
              iso3: trade.par,
              tradeflow: trade.flow,
            }
          }),
          {
            name: 'Others',
            y: +((otherImportData / worldImportData[0].val) * 100).toFixed(4),
            trade_value: otherImportData,
            color: HIGHCHART_COLORS[topImportData.length + 1],
          },
        ]
        const graphDatasetExport = [
          ...topExportData.map((trade, idx) => {
            return {
              name: getNameByISO3(trade.par),
              y: +trade.percentage,
              trade_value: trade.val,
              color: HIGHCHART_COLORS[idx],
              iso3: trade.par,
              tradeflow: trade.flow,
            }
          }),
          {
            name: 'Others',
            y: +((otherExportData / worldExportData[0].val) * 100).toFixed(4),
            trade_value: otherImportData,
            color: HIGHCHART_COLORS[topExportData.length + 1],
          },
        ]

        setTopImportSources(graphDatasetImport)
        setTopExportDest(graphDatasetExport)

        setImportPieChartOptions({
          ...highchartOptions,
          series: [
            {
              data: graphDatasetImport,
              point: {
                events: {
                  click(e) {
                    handlePartnerClicked(e.point.iso3, selectedYear, 'imports')
                  },
                },
              },
            },
          ],
          tooltip: {
            headerFormat: '',
            pointFormatter: function (this: ExtendedHighchartPiePoint) {
              const {name, percentage, trade_value, key} = this
              if (name === 'Others') {
                return `
              <strong>${key}</strong>
              <br />Share of Imports: <strong>${percentage.toFixed(2)}%</strong>`
              } else {
                var formattedPercentage = percentage < 0.01 ? '<0.01' : percentage.toFixed(2)
                return `
                <strong>${name}</strong>
                <br />Share of Imports: <strong>${formattedPercentage}%</strong>
                <br />Value of Imports: US$ ${shortenLargeNumber(trade_value)}`
              }
            },
          },
        })
        setExportPieChartOptions({
          ...highchartOptions,
          series: [
            {
              data: graphDatasetExport,
              point: {
                events: {
                  click(e) {
                    handlePartnerClicked(e.point.iso3, selectedYear, 'exports')
                  },
                },
              },
            },
          ],
          tooltip: {
            headerFormat: '',
            pointFormatter: function (this: ExtendedHighchartPiePoint) {
              const {name, percentage, trade_value, key} = this
              if (name === 'Others') {
                return `
              <strong>${key}</strong>
              <br />Share of Exports: <strong>${percentage.toFixed(2)}%</strong>`
              } else {
                var formattedPercentage = percentage < 0.01 ? '<0.01' : percentage.toFixed(2)
                return `
                <strong>${name}</strong>
                <br />Share of Exports: <strong>${formattedPercentage}%</strong>
                <br />Value of Exports: US$ ${shortenLargeNumber(trade_value)}`
              }
            },
          },
        })
      })
      .then(() => {
        setIsLoading(false)
      })
      .catch((e) => {
        console.error(e)
      })
  }

  useEffect(() => {
    setIsLoading(true)
    generateBilateralPiechartTradeData(selectedYear)
  }, [selectedYear])

  const handleYearChange = (year) => {
    setSelectedYear(+year)
  }

  return (
    <Card className='card-custom'>
      <Card.Header className='card-header-stretch'>
        <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x nav-stretch fs-6 border-0'>
          <li className='nav-item'>
            <a
              className='nav-link active'
              data-bs-toggle='tab'
              href='#tab_reporter_top_exported_commodities'
            >
              <i className='bi bi-box-arrow-right'></i>&nbsp;Top Export Destinations
            </a>
          </li>
          <li className='nav-item'>
            <a
              className='nav-link'
              data-bs-toggle='tab'
              href='#tab_reporter_top_imported_commodities'
            >
              <i className='bi bi-box-arrow-in-left'></i>&nbsp;Top Import Sources
            </a>
          </li>
        </ul>
        <Dropdown className='pt-5'>
          <Dropdown.Toggle
            variant='label-brand'
            id=''
            className='btn btn-sm btn-bold btn-label-brand dropdown-toggle fw-bold dss_graph_trade_partners_available_years_latest'
          >
            {selectedYear}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {AVAILABLE_YEARS.map((year) => {
              return (
                <Dropdown.Item key={year} onClick={() => handleYearChange(year)}>
                  {year}
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>
      <Card.Body style={{height: '600px'}}>
        {!isLoading && topExportDest.length && topImportSources.length ? (
          <div className='tab-content' id=''>
            <div
              className='tab-pane fade show active'
              id='tab_reporter_top_exported_commodities'
              role='tabpanel'
            >
              <Row>
                <h5 className='fw-normal text-primary-muted'>
                  {getNameByISO3(reporterISO3User)} exported US${' '}
                  {shortenLargeNumber(worldExportTradeValue)} to the world in {selectedYear}
                </h5>
              </Row>
              <Row>
                <p className='text-primary-muted'>
                  In {selectedYear}, {getNameByISO3(reporterISO3User)} exported US${' '}
                  {shortenLargeNumber(worldExportTradeValue)} to the world, with top destination
                  being:&nbsp;
                  {topExportDest[0]?.name} ({+topExportDest[0]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topExportDest[0]?.trade_value)}),&nbsp;
                  {topExportDest[1]?.name} ({+topExportDest[1]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topExportDest[1]?.trade_value)}),&nbsp;
                  {topExportDest[2]?.name} ({+topExportDest[2]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topExportDest[2]?.trade_value)}),&nbsp;
                  {topExportDest[3]?.name} ({+topExportDest[3]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topExportDest[3]?.trade_value)}), and&nbsp;
                  {topExportDest[4]?.name} ({+topExportDest[4]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topExportDest[4]?.trade_value)}).&nbsp;
                </p>
              </Row>
              <Row>
                <HighchartsReact highcharts={Highcharts} options={exportPieChartOptions} />
              </Row>
            </div>
            <div
              className='tab-pane fade'
              id='tab_reporter_top_imported_commodities'
              role='tabpanel'
            >
              <Row>
                <h5 className='fw-normal text-primary-muted'>
                  {getNameByISO3(reporterISO3User)} imported US${' '}
                  {shortenLargeNumber(worldImportTradeValue)} from the world in {selectedYear}
                </h5>
              </Row>
              <Row>
                <p className='text-primary-muted'>
                  In {selectedYear}, {getNameByISO3(reporterISO3User)} imported US${' '}
                  {shortenLargeNumber(worldImportTradeValue)} to the world, with top sources
                  being:&nbsp;
                  {topImportSources[0]?.name} ({+topImportSources[0]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topImportSources[0]?.trade_value)}),&nbsp;
                  {topImportSources[1]?.name} ({+topImportSources[1]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topImportSources[1]?.trade_value)}),&nbsp;
                  {topImportSources[2]?.name} ({+topImportSources[2]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topImportSources[2]?.trade_value)}),&nbsp;
                  {topImportSources[3]?.name} ({+topImportSources[3]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topImportSources[3]?.trade_value)}), and&nbsp;
                  {topImportSources[4]?.name} ({+topImportSources[4]?.y?.toFixed(2)}% valued at{' '}
                  {shortenLargeNumber(topImportSources[4]?.trade_value)}).&nbsp;
                </p>
              </Row>
              <Row>
                <HighchartsReact highcharts={Highcharts} options={importPieChartOptions} />
              </Row>
            </div>
          </div>
        ) : (
          <div className='text-center'>
            <Spinner animation='border' role='status' variant='primary'></Spinner>
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export {TopCommodityChartCard}
